module.exports = {"id":"224739","name":"Peter Olayinka","rating":"71","photo":"./data/images/photos/4/224739.png","club":{"name":"Zulte-Waregem","logo":"./data/images/clubs/Zulte-Waregem.png"},"positions":["MG","BU","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PeterOlayinka0.json
// module id = 3444
// module chunks = 0